import React from 'react';
import cn from 'classnames';
import { formatAmount, THINSP } from '@alfalab/utils';

var styles = {"component":"amount__component_e814k"};
require('./index.css');

/**
 * Компонент для отображения суммы, согласно следующему гайдлайну:
 * https://design.alfabank.ru/patterns/amount
 * Не содержит стилей кроме неразрывности строки
 *
 * @deprecated Используйте основной компонент. Стилизацию можно настроить через пропсы
 */
var PureAmount = function (_a) {
    var value = _a.value, minority = _a.minority, currency = _a.currency, rightAddons = _a.rightAddons, _b = _a.view, view = _b === void 0 ? 'default' : _b, _c = _a.showPlus, showPlus = _c === void 0 ? false : _c, className = _a.className, dataTestId = _a.dataTestId, _d = _a.codeFormat, codeFormat = _d === void 0 ? 'symbolic' : _d;
    var _e = formatAmount({
        value: value,
        currency: currency,
        minority: minority,
        view: view,
        codeFormat: codeFormat,
    }), formatted = _e.formatted, currencySymbol = _e.currencySymbol;
    return (React.createElement("span", { className: cn(styles.component, className), "data-test-id": dataTestId },
        showPlus && value > 0 ? '+' : '',
        formatted,
        currency ? "".concat(THINSP).concat(currencySymbol) : null,
        rightAddons));
};

export { PureAmount };
